import React, { FC } from "react";

import { SxProps, Theme } from "@mui/material/styles";
import {
  AccountBalance,
  AddModeratorOutlined,
  AttachMoneyOutlined,
  BorderColorOutlined,
  CasesOutlined,
  CheckCircleRounded,
  DnsOutlined,
  DocumentScanner,
  DocumentScannerOutlined,
  DoNotDisturbOutlined,
  DoubleArrowRounded,
  FactCheck,
  FlipOutlined,
  FolderSharedOutlined,
  HealthAndSafetyOutlined,
  InfoOutlined,
  LanguageOutlined,
  LibraryBooksRounded,
  LockOutlined,
  LockRounded,
  MediationOutlined,
  PersonOutlineOutlined,
  RadarOutlined,
  ReviewsOutlined,
  SanitizerOutlined,
  SecurityOutlined,
  SecurityRounded,
  TagOutlined,
  TravelExploreOutlined,
  UploadFileOutlined,
  VerifiedUserOutlined,
  VpnKeyOutlined,
  WarningRounded,
} from "@mui/icons-material";

const serviceIconMap: { [key: string]: any } = {
  audit: LockOutlined,
  authn: VerifiedUserOutlined,
  authz: AddModeratorOutlined,
  "domain-intel": DnsOutlined,
  "file-intel": TagOutlined,
  "file-scan": FlipOutlined,
  embargo: DoNotDisturbOutlined,
  geolocate: TravelExploreOutlined,
  "ip-intel": RadarOutlined,
  sanitize: SanitizerOutlined,
  scan: DocumentScannerOutlined,
  share: UploadFileOutlined,
  "url-intel": LanguageOutlined,
  "user-intel": PersonOutlineOutlined,
  redact: BorderColorOutlined,
  vault: VpnKeyOutlined,
  "fact-check": FactCheck,
  "document-scanner": DocumentScanner,
  protect: SecurityOutlined,
  health: HealthAndSafetyOutlined,
  financial: AccountBalance,
  case: CasesOutlined,
  pricing: AttachMoneyOutlined,
  default: InfoOutlined,
  check: CheckCircleRounded,
  "double-chevron-right": DoubleArrowRounded,
  warn: WarningRounded,
  "documentation-highlight": LibraryBooksRounded,
  "resources-highlight": SecurityRounded,
  "prompt-guard": ReviewsOutlined,
  "ai-guard": MediationOutlined,
  "lock-rounded": LockRounded,
};

interface Props {
  service: string;
  size?: number;
  disabled?: boolean;
  strokeColor?: string;
  sx?: SxProps<Theme>;
  strokeWidth?: string;
  className?: string;
}

const ServiceIcon: FC<Props> = ({
  service,
  size = 32,
  disabled = false,
  strokeColor = "#FFF",
  strokeWidth = "0.5px",
  sx = {},
  className = "",
}) => {
  if (service === "none") {
    return "";
  }

  const Icon =
    service in serviceIconMap
      ? serviceIconMap[service]
      : serviceIconMap.default;
  const iconClass = disabled ? "disabled" : "active";
  const pathStyle = {
    "& path": {
      stroke: strokeColor,
      strokeWidth: strokeWidth,
    },
  };
  const iconStyle = { fontSize: size, ...pathStyle, ...sx };

  return <Icon className={`${iconClass} ${className}`} sx={iconStyle} />;
};

export default ServiceIcon;
